// Module
var code = "<div class=\"c-datatable-moreButtonCell u-sizeFullWidth ui-grid-cell-contents\" title=\"{{row.entity.created | date :'short' }}\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div>{{row.entity.created | date :\"short\" }}</div>\n    </div>\n</div>";
// Exports
module.exports = code;